import { defineComponent as _defineComponent } from 'vue'
import { computed } from '@nuxtjs/composition-api';
import { Icon, Variant } from './types';

type PortfolioButtonProps = {
  icon?: Icon;
  variant?: Variant;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'PortfolioButton',
  props: {
    icon: { default: Icon.Pencil },
    variant: { default: Variant.Transparent }
  },
  setup(__props: any) {

const props = __props as { icon: Icon, variant: Variant };



const rootClass = computed(() => ({
  'portfolio-button': true,
  [`portfolio-button--${props.variant}`]: true,
}));

return { __sfc: true,props, rootClass }
}

})